import * as React from 'react';

import { Row, Col, Form, Tabs, TimePicker, DatePicker, Skeleton } from 'antd';
import {
  Input,
  Notification,
  Select,
  SelectOption as Option,
  Space,
  Text,
} from 'farmhub-ui-core';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from 'app';
import { Footer, PageTitleBar } from 'components';
import { ClockIcon, SlackIcon, TelegramContactIcon } from 'components/Icon';
import MainContent from 'components/Layout/MainContent';
import {
  findEntityReportById,
  saveRoute,
  setBreadcrumb,
  updateEntityReport,
  updateSavedListEntityReport,
} from 'slice';
import { theme } from 'styled';
import {
  NOTIFY_APP,
  REPORT_OPTION,
  DAY_OF_WEEK,
  REPORT_APP,
  ENTITY_REPORT_TYPE,
  ENTITY_REPORT_STATUS,
  ENTITY_REPORT_TYPE_VALUE,
  replaceItemInList,
} from 'utils';

import { ReportFeature } from './ReportFeature';
import { SlackApp } from './SlackApp';
import { TelegramApp } from './TelegramApp';

const WrapSelectTimeType = styled.div`
  display: flex;
  align-items: center;
`;

const WrapperTimePicker = styled.div`
  display: flex;
  justify-content: space-between;
  width: 340px;
  height: 42px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.colors.border.main};
`;

const WrapDateTime = styled.div`
  display: flex;
`;

const WrapTime = styled.div<{ typeReport: number }>`
  width: ${p =>
    ENTITY_REPORT_TYPE_VALUE.DATE_REPORT == p.typeReport ? '290px' : '145px'};
  height: 42px;
  margin: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${p => p.theme.colors.border.light};
  .ant-picker {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    height: 30px;
    width: 80px;
  }

  .ant-picker-focused {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    box-shadow: none;
  }

  .anticon,
  .anticon-close-circle {
    display: none;
  }
`;

const RangeTimeWrapper = styled.div`
  width: 290px;
  height: 42px;
  margin: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${p => p.theme.colors.border.light};
  .ant-picker {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    height: 30px;
    width: 100%;
  }

  .ant-picker-focused {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    box-shadow: none;
  }

  .anticon-close-circle {
    display: none;
  }
`;

const WrapDayOfWeek = styled.div`
  display: flex;
  align-items: center;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    box-shadow: none;
  }

  .ant-select-selector {
    border: none;
    box-shadow: none;
  }
`;

const WrapDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 145px;
  padding: 5px;
  border-right: 1px solid ${p => p.theme.colors.border.light};
  margin: 0px;
  color: ${props => props.theme.colors.text.secondary};
  .ant-picker {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    height: 30px;
    width: 80px;
  }

  .ant-picker-focused {
    border: none !important;
    border-radius: 0px !important;
    outline: none !important;
    box-shadow: none;
  }

  //.ant-form-item-explain,
  .ant-form-item-explain-error {
    position: absolute;
    bottom: -30px;
    width: 200px;
    right: 0px;
  }

  .anticon,
  .anticon-close-circle {
    display: none;
  }
`;

const WrapHyphen = styled.div`
  width: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrapperClockIcon = styled.div`
  border-left: 1px solid ${p => p.theme.colors.border.light};
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type UpdateBodyProps = {
  id: string;
  name?: string;
  status?: number;
  entityReportApps?: any[];
  type?: number;
  statisticOption?: any[];
  receivedReportTime?: any;
  statisticStartTime?: any;
  statisticEndTime?: any;
  googleSheetUrl?: string;
  googleSheetInfo?: {
    sheetName: string;
    row: string;
    column: string;
  };
};

type RelativeDate = {
  minutes?: number;
  hours?: number;
  date?: number;
  dayOfWeek?: number;
  absoluteTime?: string;
};

export const EntityReportUpdatePage = ({ match }): JSX.Element => {
  const [form] = Form.useForm();
  const [listSlackGroup, setListSlackGroup] = React.useState<any[]>([]);
  const [listTelegramGroup, setListTelegramGroup] = React.useState<any[]>([]);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isUpdateGroup, setIsUpdateGroup] = React.useState<boolean>(false);
  const [typeReport, setTypeReport] = React.useState<number>();
  const [bodyUpdate, setBodyUpdate] = React.useState<any>({});
  const [title, setTitle] = React.useState<string>('');
  const [isLoadingData, setIsLoadingData] = React.useState(false);
  const savedList = useAppSelector(state => state.entityReport.savedList);
  const location = useLocation();

  const handleSetBodyUpdate = value => {
    setBodyUpdate(prevState => {
      return { ...prevState, ...value };
    });
  };

  React.useEffect(() => {
    const initData = async () => {
      setIsLoadingData(true);

      try {
        const { data } = await dispatch(
          findEntityReportById(match.params.id)
        ).unwrap();

        dispatch(setBreadcrumb({ title: data?.name ?? 'Cập nhật' }));

        if (data?.statisticOption?.length > 0) {
          data?.statisticOption.forEach(option => {
            option?.options.forEach(item => {
              form.setFieldsValue({ [`option${option.type}.${item}`]: true });
            });
            if (
              data?.type === ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT &&
              option?.options?.length
            ) {
              form.setFieldsValue({
                [`option${option.type}`]: option?.options[0],
              });
            }
          });
        }

        // slackStatus
        if (data?.entityReportApps.length > 0) {
          data?.entityReportApps.forEach(item => {
            if (item.type == REPORT_APP.SLACK) {
              setListSlackGroup(item.urlInformation);
              form.setFieldsValue({
                slackStatus: item.status == ENTITY_REPORT_STATUS.ACTIVATED,
              });
            } else if (item.type == REPORT_APP.TELEGRAM) {
              setListTelegramGroup(item.urlInformation);
              form.setFieldsValue({
                telegramStatus: item.status == ENTITY_REPORT_STATUS.ACTIVATED,
              });
            }
          });
        }

        setTypeReport(data?.type);

        form.setFieldsValue({
          ...data,
        });

        form.setFieldsValue({
          name: data?.name || '',
          entityReportApps: data?.entityReportApps || '',
          timeReport: moment(
            `${data?.receivedReportTime.hours}:${data?.receivedReportTime.minutes}`,
            'HH:mm'
          ),
          type: data?.type,
          googleSheetInfoSheetName: data?.googleSheetInfo?.sheetName,
          googleSheetInfoRow: data?.googleSheetInfo?.row,
          googleSheetInfoColumn: data?.googleSheetInfo?.column,
        });

        if (data?.type == ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT) {
          form.setFieldsValue({
            dayOfWeekReport: data?.receivedReportTime?.dayOfWeek,
          });
        } else if (data?.type == ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT) {
          form.setFieldsValue({
            dateReport: moment(`${data?.receivedReportTime.date}`, 'DD'),
          });
        } else {
          form.setFieldsValue({
            dateReport: moment(`01`, 'DD'),
          });
        }

        form.setFieldsValue({
          timeReportStart: moment(
            `${data.statisticStartTime?.hours}:${data.statisticStartTime?.minutes}`,
            'HH:mm'
          ),
        });

        if (data?.type == ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT) {
          form.setFieldsValue({
            dayOfWeekReportStart: data.statisticStartTime?.dayOfWeek,
          });
        } else if (data?.type == ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT) {
          form.setFieldsValue({
            dateReportStart: moment(`${data.statisticStartTime?.date}`, 'DD'),
          });
        } else {
          form.setFieldsValue({
            dateReportStart: moment(`01`, 'DD'),
          });
        }

        if (data?.type == ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT) {
          form.setFieldsValue({
            dayOfWeekReportEnd: data.statisticEndTime?.dayOfWeek,
          });
        }

        form.setFieldsValue({
          timeReportEnd: moment(
            `${data.statisticEndTime?.hours}:${data.statisticEndTime?.minutes}`,
            'HH:mm'
          ),
        });

        if (data?.type == ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT) {
          form.setFieldsValue({
            dateReportEnd: moment(`${data.statisticEndTime?.date}`, 'DD'),
          });
        } else {
          form.setFieldsValue({
            dateReportEnd: moment(`01`, 'DD'),
          });
        }

        if (data?.type == ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT) {
          form.setFieldsValue({
            timeReportASAP: [
              moment(data?.statisticStartTime?.absoluteTime),
              moment(data?.statisticEndTime?.absoluteTime),
            ],
          });
        }
      } catch (error: any) {
        Notification('error', 'Tải dữ liệu thất bại', error);
      } finally {
        setIsLoadingData(false);
      }
    };

    initData();
  }, [dispatch, form, match.params.id]);

  const handleSubmitBodyUpdate = () => {
    dispatch(saveRoute(location.pathname));

    form.validateFields().then(async values => {
      setIsSubmitting(true);
      const feature: any[] = [];
      const isReportTypeASAP =
        Number(values?.type) === ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT;

      if (Object.keys(bodyUpdate).length > 0) {
        Object.keys(REPORT_OPTION).forEach(item => {
          const option: any = {
            type: REPORT_OPTION[item].type,
            options: [],
          };

          if (isReportTypeASAP) {
            option.options.push(values[`option${REPORT_OPTION[item].type}`]);
          } else {
            REPORT_OPTION[item].options.forEach(childItem => {
              if (
                values[`option${REPORT_OPTION[item].type}.${childItem.type}`] ==
                true
              ) {
                option.options.push(childItem.type);
              } else if (
                values[`option${REPORT_OPTION[item].type}.${childItem.type}`] ==
                false
              ) {
                option.options = option.options.filter(
                  item => item != childItem.type
                );
              }
            });
          }

          feature.push(option);
        });
      }

      const receivedReportTime: RelativeDate = {};
      const statisticEndTime: RelativeDate = {};
      const statisticStartTime: RelativeDate = {};

      if (
        bodyUpdate?.timeReport ||
        bodyUpdate?.dayOfWeekReport ||
        bodyUpdate?.dateReport
      ) {
        receivedReportTime.hours = values?.timeReport
          ? values.timeReport?._d.getHours()
          : 12;
        receivedReportTime.minutes = values?.timeReport
          ? values.timeReport?._d.getMinutes()
          : 0;

        if (values?.dayOfWeekReport) {
          receivedReportTime.dayOfWeek = values.dayOfWeekReport;
        }

        if (values?.dateReport) {
          receivedReportTime.date = values.dateReport?._d.getDate();
        }
      }

      if (
        bodyUpdate?.timeReportEnd ||
        bodyUpdate?.timeReportStart ||
        bodyUpdate?.dayOfWeekReportEnd ||
        bodyUpdate?.dayOfWeekReportStart ||
        bodyUpdate?.dateReportEnd ||
        bodyUpdate?.dateReportStart
      ) {
        statisticEndTime.hours = values?.timeReportEnd
          ? values.timeReportEnd?._d.getHours()
          : 12;

        statisticEndTime.minutes = values?.timeReportEnd
          ? values.timeReportEnd?._d.getMinutes()
          : 0;

        if (values?.dayOfWeekReport) {
          statisticEndTime.dayOfWeek = values.dayOfWeekReportEnd;
        }

        if (values?.dateReportEnd) {
          statisticEndTime.date = values.dateReportEnd?._d.getDate();
        }

        statisticStartTime.hours = values?.timeReportStart
          ? values.timeReportStart?._d.getHours()
          : 12;
        statisticStartTime.minutes = values?.timeReportStart
          ? values.timeReportStart?._d.getMinutes()
          : 0;

        if (values?.dayOfWeekReport) {
          statisticStartTime.dayOfWeek = values.dayOfWeekReportStart;
        }

        if (values?.dateReport) {
          statisticStartTime.date = values.dateReportStart?._d.getDate();
        }
      }

      if (
        values?.timeReportStart?._d?.getDate() >
        values?.timeReportEnd?._d?.getDate()
      ) {
        Notification(
          'error',
          'Vui lòng nhập thời gian bắt đầu nhỏ hơn thời gian kết thúc!'
        );
      }

      if (values?.timeReportASAP) {
        statisticStartTime.absoluteTime = moment(
          values?.timeReportASAP[0]
        ).format();
        statisticEndTime.absoluteTime = moment(
          values?.timeReportASAP[1]
        ).format();
      }

      const updateData: UpdateBodyProps = {
        ...(bodyUpdate?.name ? { name: bodyUpdate?.name } : {}),
        id: match.params.id,
        ...(bodyUpdate.googleSheetUrl
          ? { googleSheetUrl: bodyUpdate.googleSheetUrl }
          : {}),
        ...(bodyUpdate.googleSheetInfoSheetName != undefined ||
        bodyUpdate.googleSheetInfoRow != undefined ||
        bodyUpdate.googleSheetInfoColumn != undefined
          ? {
              googleSheetInfo: {
                sheetName:
                  bodyUpdate.googleSheetInfoSheetName ||
                  values.googleSheetInfoSheetName,
                row: bodyUpdate.googleSheetInfoRow || values.googleSheetInfoRow,
                column:
                  bodyUpdate.googleSheetInfoColumn ||
                  values.googleSheetInfoColumn,
              },
            }
          : {}),
        // status: NOTIFY_STATUS.ACTIVATED,
        ...(!isReportTypeASAP && isUpdateGroup ? { entityReportApps: [] } : {}),
        ...(Object.keys(receivedReportTime).length
          ? { receivedReportTime }
          : {}),
        ...(bodyUpdate?.type >= 0 ? { type: Number(bodyUpdate?.type) } : {}),
        ...(Object.keys(statisticEndTime).length ? { statisticEndTime } : {}),
        ...(Object.keys(statisticStartTime).length
          ? { statisticStartTime }
          : {}),
        ...(Object.keys(feature).length > 0
          ? { statisticOption: feature }
          : {}),
      };

      if (!isReportTypeASAP && isUpdateGroup && updateData?.entityReportApps) {
        const entityReportApps = form.getFieldValue('entityReportApps');

        updateData?.entityReportApps.push({
          id: entityReportApps.find(item => item.type == REPORT_APP.SLACK)?.id,
          type: NOTIFY_APP.SLACK,
          status:
            values?.slackStatus == true
              ? ENTITY_REPORT_STATUS.ACTIVATED
              : ENTITY_REPORT_STATUS.DEACTIVATED,
          urlInformation: listSlackGroup || [],
        });
        updateData?.entityReportApps.push({
          id: entityReportApps.find(item => item.type == REPORT_APP.TELEGRAM)
            ?.id,
          type: NOTIFY_APP.TELEGRAM,
          status:
            values?.telegramStatus == true
              ? ENTITY_REPORT_STATUS.ACTIVATED
              : ENTITY_REPORT_STATUS.DEACTIVATED,
          urlInformation: listTelegramGroup || [],
        });
      }

      try {
        const { data } = await dispatch(
          updateEntityReport(updateData)
        ).unwrap();

        const onChangeListTempSaved = data => {
          dispatch(updateSavedListEntityReport(data));
        };

        replaceItemInList(
          {
            id: data?.id,
            ...data,
          },
          savedList,
          onChangeListTempSaved
        );

        history.goBack();
      } catch (error: any) {
        Notification('error', 'Cập nhật báo cáo thất bại', error);
      } finally {
        setIsSubmitting(false);
        setIsUpdateGroup(false);
      }
    });
  };

  return (
    <Form form={form} onValuesChange={handleSetBodyUpdate}>
      <MainContent>
        <PageTitleBar
          title={
            <>
              <Text
                color="dark"
                lineHeight="auto"
                textTransform="uppercase"
                weight="extraBold"
              >
                Cập nhật báo cáo nhận đơn:
              </Text>
              <Space width={5} />
              {isLoadingData ? (
                <Skeleton.Input
                  size="small"
                  style={{ width: 300, alignItems: 'center' }}
                />
              ) : (
                <Text
                  color="main"
                  lineHeight="auto"
                  textTransform="uppercase"
                  weight="extraBold"
                >
                  {form.getFieldValue('name')}
                </Text>
              )}
            </>
          }
        />
        <Space height={25} />

        <Text size="xxs" textTransform="uppercase" weight="extraBold">
          Thông tin cơ bản
        </Text>
        <Space height={15} />

        <Form.Item style={{ marginBottom: '0px' }}>
          <Row>
            <Col
              lg={6}
              md={6}
              sm={24}
              style={{ display: 'flex', alignItems: 'center', height: '50px' }}
            >
              <Text>Tiêu đề:</Text>
            </Col>
            <Col lg={18}>
              <Form.Item name="name">
                <Input
                  height={theme.input.height.md}
                  placeholder="Nhập tiêu đề tại đây"
                  value={title}
                  width="693px"
                  onChange={e => {
                    setTitle(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Row>
          <Col
            lg={6}
            md={6}
            sm={24}
            style={{ display: 'flex', alignItems: 'center', height: '50px' }}
          >
            <Text>Link google sheet:</Text>
          </Col>
          <Col lg={18}>
            <Form.Item name="googleSheetUrl">
              <Input
                height={theme.input.height.md}
                placeholder="Nhập url tại đây"
                value={title}
                width="693px"
                onChange={e => {
                  setTitle(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        {typeReport != undefined &&
          typeReport == ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
            <>
              <Row>
                <Col
                  lg={6}
                  md={6}
                  sm={24}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '50px',
                  }}
                >
                  <Text>Thông tin google sheet:</Text>
                </Col>
                <Col lg={18}>
                  <Row justify="space-between" style={{ width: '693px' }}>
                    <Form.Item
                      name="googleSheetInfoSheetName"
                      style={{ marginBottom: '0px' }}
                    >
                      <Input
                        height={theme.input.height.md}
                        placeholder="Tên sheet"
                        width="224px"
                      />
                    </Form.Item>
                    <Form.Item
                      name="googleSheetInfoRow"
                      style={{ marginBottom: '0px' }}
                    >
                      <Input
                        height={theme.input.height.md}
                        placeholder="Số hàng chứa mã code của KH"
                        width="224px"
                      />
                    </Form.Item>
                    <Form.Item
                      name="googleSheetInfoColumn"
                      style={{ marginBottom: '0px' }}
                    >
                      <Input
                        height={theme.input.height.md}
                        placeholder="Số cột chứa mã SKU của SP"
                        width="224px"
                      />
                    </Form.Item>
                  </Row>
                </Col>
              </Row>
              <Space height={20} />
            </>
          )}
        <Row>
          <Col
            lg={6}
            md={6}
            sm={24}
            style={{ display: 'flex', alignItems: 'center', height: '50px' }}
          >
            <Text>Thời gian báo cáo:</Text>
          </Col>
          <Col lg={18}>
            <WrapSelectTimeType>
              <Form.Item name="type" style={{ marginBottom: '0px' }}>
                <Select
                  showSearch
                  height={theme.select.height.md}
                  optionLabelProp="label"
                  placeholder="Chọn loại báo cáo"
                  styles={{
                    borderRadius: '0px 6px 6px 0px',
                    borderLeft: 'none',
                  }}
                  width="340px"
                  onChange={e => {
                    setTypeReport(e);
                  }}
                >
                  {ENTITY_REPORT_TYPE.map((item: any) => (
                    <Option key={item.type} label={item.name} value={item.type}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {typeReport != undefined &&
                typeReport !== ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                  <>
                    <Space width={12} />
                    <WrapperTimePicker>
                      <WrapDateTime>
                        <WrapTime typeReport={typeReport}>
                          <Form.Item
                            name="timeReport"
                            style={{ marginBottom: '0px', border: 'none' }}
                          >
                            <TimePicker format="HH:mm" placeholder="Chọn giờ" />
                          </Form.Item>
                        </WrapTime>

                        <WrapDayOfWeek>
                          {typeReport ===
                            ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT && (
                            <Form.Item
                              name="dayOfWeekReport"
                              style={{ marginBottom: '0px' }}
                            >
                              <Select
                                showSearch
                                height={theme.select.height.sm}
                                placeholder="Chọn thứ"
                                styles={{
                                  borderRadius: '0px 6px 6px 0px',
                                  border: 'none !important',
                                  borderLeft: 'none',
                                }}
                                width="145px"
                                onChange={e => {
                                  console.log(e);
                                }}
                              >
                                {(DAY_OF_WEEK || []).map((item: any) => (
                                  <Option value={item.type}>{item.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}
                        </WrapDayOfWeek>
                        {typeReport ===
                          ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT && (
                          <WrapDate>
                            Ngày:{' '}
                            <Form.Item
                              name="dateReport"
                              style={{ marginBottom: '0px' }}
                            >
                              <DatePicker
                                format="DD"
                                picker="date"
                                placeholder="Chọn ngày"
                                size="small"
                              />
                            </Form.Item>
                          </WrapDate>
                        )}
                      </WrapDateTime>
                      {/* Quý: <DatePicker size="small" picker="quarter" format="Q" /> */}
                      <WrapperClockIcon>
                        <ClockIcon width={18} />
                      </WrapperClockIcon>
                    </WrapperTimePicker>
                  </>
                )}
            </WrapSelectTimeType>
          </Col>
        </Row>
        <Space height={20} />
        <Row>
          <Col
            lg={6}
            md={6}
            sm={24}
            style={{ display: 'flex', alignItems: 'center', height: '50px' }}
          >
            <Text>Thời gian tổng hợp dữ liệu</Text>
          </Col>
          <Col lg={18}>
            <Row>
              <WrapperTimePicker>
                <WrapDateTime>
                  {typeReport != undefined &&
                    typeReport !== ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                      <WrapTime typeReport={typeReport}>
                        <Form.Item
                          name="timeReportStart"
                          style={{ marginBottom: '0px', border: 'none' }}
                        >
                          <TimePicker
                            defaultValue={moment('12', 'HH:mm')}
                            format="HH:mm"
                            placeholder="Chọn giờ"
                          />
                        </Form.Item>
                      </WrapTime>
                    )}

                  {typeReport != undefined &&
                    typeReport === ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT && (
                      <WrapDayOfWeek>
                        <Form.Item
                          name="dayOfWeekReportStart"
                          style={{ marginBottom: '0px' }}
                        >
                          <Select
                            showSearch
                            height={theme.select.height.sm}
                            placeholder="Chọn thứ"
                            styles={{
                              borderRadius: '0px 6px 6px 0px',
                              border: 'none !important',
                              borderLeft: 'none',
                            }}
                            width="145px"
                            onChange={e => {
                              console.log(e);
                            }}
                          >
                            {(DAY_OF_WEEK || []).map((item: any) => (
                              <Option value={item.type}>{item.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </WrapDayOfWeek>
                    )}

                  {typeReport != undefined &&
                    typeReport === ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT && (
                      <WrapDate>
                        Ngày:{' '}
                        <Form.Item
                          name="dateReportStart"
                          style={{ marginBottom: '0px' }}
                        >
                          <DatePicker
                            format="DD"
                            picker="date"
                            placeholder="Chọn ngày"
                            size="small"
                          />
                        </Form.Item>
                      </WrapDate>
                    )}

                  {typeReport != undefined &&
                    typeReport === ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                      <RangeTimeWrapper>
                        <Form.Item
                          name="timeReportASAP"
                          style={{ marginBottom: '0px', border: 'none' }}
                        >
                          <DatePicker.RangePicker
                            showTime
                            format="DD/MM/YYYY HH:mm"
                            suffixIcon={<></>}
                          />
                        </Form.Item>
                      </RangeTimeWrapper>
                    )}
                </WrapDateTime>
                {/* Quý: <DatePicker size="small" picker="quarter" format="Q" /> */}
                <WrapperClockIcon>
                  <ClockIcon width={18} />
                </WrapperClockIcon>
              </WrapperTimePicker>
              {typeReport != undefined &&
                typeReport !== ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
                  <>
                    <WrapHyphen>-</WrapHyphen>
                    <WrapperTimePicker>
                      <WrapDateTime>
                        <WrapTime typeReport={typeReport}>
                          <Form.Item
                            name="timeReportEnd"
                            style={{ marginBottom: '0px', border: 'none' }}
                          >
                            <TimePicker
                              defaultValue={moment('12', 'HH:mm')}
                              format="HH:mm"
                              placeholder="Chọn giờ"
                            />
                          </Form.Item>
                        </WrapTime>

                        {typeReport ===
                          ENTITY_REPORT_TYPE_VALUE.WEEK_REPORT && (
                          <WrapDayOfWeek>
                            <Form.Item
                              name="dayOfWeekReportEnd"
                              style={{ marginBottom: '0px' }}
                            >
                              <Select
                                showSearch
                                height={theme.select.height.sm}
                                placeholder="Chọn thứ"
                                styles={{
                                  borderRadius: '0px 6px 6px 0px',
                                  border: 'none !important',
                                  borderLeft: 'none',
                                }}
                                width="145px"
                              >
                                {(DAY_OF_WEEK || []).map((item: any) => (
                                  <Option value={item.type}>{item.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </WrapDayOfWeek>
                        )}

                        {typeReport ===
                          ENTITY_REPORT_TYPE_VALUE.MONTH_REPORT && (
                          <WrapDate>
                            Ngày:{' '}
                            <Form.Item
                              name="dateReportEnd"
                              style={{ marginBottom: '0px' }}
                            >
                              <DatePicker
                                // defaultValue={moment('12', 'DD')}
                                format="DD"
                                picker="date"
                                placeholder="Chọn ngày"
                                size="small"
                              />
                            </Form.Item>
                          </WrapDate>
                        )}
                      </WrapDateTime>
                      {/* Quý: <DatePicker size="small" picker="quarter" format="Q" /> */}
                      <WrapperClockIcon>
                        <ClockIcon width={18} />
                      </WrapperClockIcon>
                    </WrapperTimePicker>
                  </>
                )}
            </Row>
          </Col>
        </Row>
        <Space height={20} />
        <Row>
          <Col lg={6} md={6} sm={24}>
            <Text>Cài đặt</Text>
          </Col>
          <Col lg={18}>
            {Object.keys(REPORT_OPTION).map(item => (
              <ReportFeature
                feature={REPORT_OPTION[item]}
                form={form}
                typeReport={typeReport}
                onSetBodyUpdate={handleSetBodyUpdate}
              />
            ))}
          </Col>
        </Row>
        {typeReport != undefined &&
          typeReport != ENTITY_REPORT_TYPE_VALUE.ASAP_REPORT && (
            <>
              <Space height={50} />
              <Text size="xxs" textTransform="uppercase" weight="extraBold">
                Ứng dụng thông báo
              </Text>
              <Space height={15} />
              <Tabs defaultActiveKey="1">
                <Tabs.TabPane
                  key="1"
                  tab={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <SlackIcon width={24} />
                      <Space width={10} />
                      Ứng dụng Slack
                    </span>
                  }
                >
                  <SlackApp
                    form={form}
                    isUpdateGroup={isUpdateGroup}
                    listSlackGroup={listSlackGroup}
                    setIsUpdateGroup={setIsUpdateGroup}
                    setListSlackGroup={setListSlackGroup}
                    onSetBodyUpdate={handleSetBodyUpdate}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane
                  key="2"
                  tab={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <TelegramContactIcon width={24} />
                      <Space width={10} />
                      Ứng dụng Telegram
                    </span>
                  }
                >
                  <TelegramApp
                    form={form}
                    isUpdateGroup={isUpdateGroup}
                    listTelegramGroup={listTelegramGroup}
                    setIsUpdateGroup={setIsUpdateGroup}
                    setListTelegramGroup={setListTelegramGroup}
                    onSetBodyUpdate={handleSetBodyUpdate}
                  />
                </Tabs.TabPane>
              </Tabs>
            </>
          )}
      </MainContent>
      <Footer
        content={['Hủy cập nhật', 'Hoàn thành']}
        disabled={Object.keys(bodyUpdate).length === 0 && !isUpdateGroup}
        isSubmitting={isSubmitting}
        onSubmit={
          (Object.keys(bodyUpdate).length > 0 || isUpdateGroup) &&
          handleSubmitBodyUpdate
        }
      />
    </Form>
  );
};
